import { useAuth0 } from '@auth0/auth0-react';

export const useIsEnabledForUsers = () => {
  const { user } = useAuth0();

  const allowedUserIds = [
    'google-oauth2|115318477849923133641',
    'google-oauth2|113238590142888685973',
    'auth0|68d67d39e77b86b713da4c5f',
  ];
  return allowedUserIds === undefined || (!!user?.sub && allowedUserIds.includes(user.sub));
};
